import { render, staticRenderFns } from "./StepMoverCascaderWrapper.vue?vue&type=template&id=22ba4c77&"
import script from "./StepMoverCascaderWrapper.vue?vue&type=script&lang=js&"
export * from "./StepMoverCascaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports